<!-- 选择层级地图 -->
<template>
  <yxt-drawer
    custom-class='yxtbiz_gwnl_custom_drawer'
    :destroy-on-close="true"
    size="1060px"
    :visible.sync="dialogVisible"
    :before-close="beforeDrawClose"
    :title="type === 0 ? $t('pc_biz_select_tamp_label') : $t('pc_biz_select_tmap_chpo')"
  >
    <div class="yxtbiz-select-maps">
      <div class='yxtbiz-select-maps-wrap'>
        <div>
          <yxt-popover
            :append-to-body="false"
            popper-class="yxtbiz-exam-arrange-selector__popover"
            placement="bottom-start"
            :visible-arrow="false"
            v-model="showMoreFilter"
          >
            <yxt-button slot="reference" plain class="yxtbiz-filter-btn mr12">
              <yxt-svg
                width="20px"
                height="20px"
                icon-class="filter"
                class="v-top"
              />
              <span class="ml8 v-top">{{
                  $t('pc_biz_common_lbl_moreFilter')
                }}</span>
              <i
                class="ml8"
                :class="
                showMoreFilter ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down'
              "
              ></i>
            </yxt-button>
            <yxt-form :inline="true">
              <yxt-row :gutter="20">
                <yxt-col :span="12" class='mb12'>
                  <yxt-form-item
                    label-width="100px"
                    :label="$t('pc_biz_tmap_lbl_publishdate')/* 层级地图发布时间 */"
                  >
                    <yxt-date-picker
                      v-model="publishDate"
                      format="yyyy-MM-dd"
                      type="daterange"
                      :range-separator="$t('pc_biz_ote_lbl_to')"
                      :start-placeholder="$t('pc_biz_ote_lbl_starttime')"
                      :end-placeholder="$t('pc_biz_ote_lbl_endtime')"
                      @change="search(1)"
                      value-format='yyyy-MM-dd'
                    >
                    </yxt-date-picker>
                  </yxt-form-item>
                </yxt-col>
              </yxt-row>
            </yxt-form>
          </yxt-popover>
          <yxt-select
            v-if="showRole"
            v-model="params.flag"
            :placeholder="$t('pc_select_placeholder')"
            class="mr12"
            style="width: 144px;"
            @change="search(1)"
          >
            <yxt-option
              v-for="item in roleType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </yxt-select>
          <yxt-input
            v-model="params.keyword"
            class="mb16"
            style="width: 240px;"
            :placeholder="$t('pc_biz_gwnl_tmap_selectbyname')"
            searchable
            @search="search(1)"
          />
        </div>
        <div
          class='yxtbiz-select-maps-table'
        >
<!--          层级地图-->
          <yxt-table
            v-if='type === 0'
            ref="table"
            height='100%'
            v-loading="loading"
            :data="list"
            :row-key="getRowKey"
            @sort-change="handleSortChange"
            @select="handleSelect"
            @select-all="handleSelectAll"
            :tree-props="{children: 'barrier'}"
            :default-sort="{ prop: params.orderby, order: params.direction }"
          >
            <yxt-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            />
            <yxt-table-column
              prop="name"
              min-width="228"
              show-overflow-tooltip
              :label="$t('pc_biz_tmap_lbl_name')"
            >
              <template slot-scope="{row}">
                {{ row.name || '--' }}
              </template>
            </yxt-table-column>
            <yxt-table-column
              prop="releaseUserName"
              :label="$t('pc_biz_gwnl_lbl_publishperson')"
              show-overflow-tooltip
              width="140"
            >
              <template slot-scope="scope">
                <yxtbiz-user-name :name="scope.row.releaseUserName || '--'" />
              </template>
            </yxt-table-column>
            <yxt-table-column
              sortable="custom"
              prop="releaseDate"
              :label="$t('pc_biz_global_lbl_updateTime')"
              show-overflow-tooltip
              width="180"
            >
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.releaseDate | formatDate('yyyy-MM-dd hh:mm') }}</span>
              </template>
            </yxt-table-column>
          </yxt-table>
<!--          关卡-->
          <yxt-table
            v-else
            ref="table"
            height='100%'
            v-loading="loading"
            :data="list"
            :row-key="getRowKey"
            @sort-change="handleSortChange"
            :tree-props="{children: 'barrier'}"
            :default-sort="{ prop: params.orderby, order: params.direction }"
          >
            <yxt-table-column
              prop="name"
              min-width="228"
              show-overflow-tooltip
              :label="$t('pc_biz_tmap_lbl_name')"
            >
              <template slot-scope="{row}">
                <template>
                  <yxt-checkbox
                    v-model='selectedBarrierAndMap[row.id]'
                    @change='barrierModeCheckboxChange(row)'
                  ></yxt-checkbox>
                  <span class='ml12'>{{ row.name || '--' }}</span>
                </template>
              </template>
              <template slot="header">
                <yxt-checkbox
                  :indeterminate='isIndeterminate'
                  v-model='checkAllModel'
                  @change='barrierModeAllCheckboxChange'
                ></yxt-checkbox><span class='ml12'>{{ $t('pc_biz_tmap_lbl_name').d('层级地图名称') }}</span>
              </template>
            </yxt-table-column>
            <yxt-table-column
              prop="releaseUserName"
              :label="$t('pc_biz_gwnl_lbl_publishperson')"
              show-overflow-tooltip
              width="140"
            >
              <template slot-scope="scope">
                <yxtbiz-user-name :name="scope.row.releaseUserName || '--'" />
              </template>
            </yxt-table-column>
            <yxt-table-column
              prop="releaseDate"
              :label="$t('pc_biz_global_lbl_updateTime')"
              show-overflow-tooltip
              width="180"
            >
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.releaseDate | formatDate('yyyy-MM-dd hh:mm') }}</span>
              </template>
            </yxt-table-column>
          </yxt-table>
        </div>
        <div class="clearfix">
          <yxt-row type="flex" align="end" justify="space-between" class="col-flex-1 align-end">
            <yxt-button type="text" class="mt16" :disabled="!list.length" :loading="selectAllLoading" @click="selectAllData">{{$t('pc_biz_shoptour_all_filter_results')}}</yxt-button>
            <yxt-pagination
              class="mt16"
              @current-change="handleCurrentChange"
              :current-page.sync="pager.currentPage"
              :page-size="pager.pageSize"
              layout="total, prev, pager, next"
              :total="pager.total"
            />
          </yxt-row>
        </div>
      </div>
      <div class="select-maps__result">
        <div class="result-list">
          <div class="result-list__content">
            <yxt-button
              v-if="!selectedList.length"
              class="result-list__select-tip"
              type="text"
              disabled
            >
              {{ $t('pc_comp_select_placeholder') }}
            </yxt-button>
            <div class='result-list__select-count'>{{$t('pc_biz_kng_lbl_selected')}} {{selectedList.length}} / {{limit}}</div>
            <div style="height: 100%; overflow: hidden;">
              <yxt-scrollbar :fit-height="true">
                <div
                  v-for="item in selectedList"
                  :key="item.id"
                >
                  <yxt-tooltip
                    effect="dark"
                    :content="item.name"
                    placement="top"
                  >
                    <span style='display: inline-block'>
                      <yxt-tag
                        class='select-maps__tag mb5 mr5 ellipsis'
                        style='max-width: 160px;'
                        type="info"
                        size="mini"
                        closable
                        @close="handleSelectionClose(item)"
                      >
                        <span class='select-maps__taglabel'>{{ item.name }}</span>
                      </yxt-tag>
                    </span>
                  </yxt-tooltip>
                </div>
              </yxt-scrollbar>
            </div>
            <yxt-button
              class="result-list__select-clear"
              type="text"
              :disabled="!selectedList.length"
              @click="clearAllSelection"
            >
              {{ $t('pc_biz_cer_btn_clearall') }}
            </yxt-button>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <yxt-button
        plain
        @click="cancel"
      >
        {{ $t("pc_biz_core_btn_cancel") }}
      </yxt-button>
      <yxt-button
        type="primary"
        @click="handleSelection"
      >
        {{ $t("pc_biz_core_btn_determine") }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import api from './service';
import dateUtil from 'yxt-biz-pc/src/utils/date';

export default {
  name: 'YxtbizSelectMaps',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultValue: Array,
    showRole: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1000
    },
    type: {
      type: Number,
      default: 0 // 0 选择层级地图 1 选择关卡
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    sp: {
      type: Boolean,
      default: false // 奇点新人发
    }
  },
  data() {
    return {
      dialogVisible: false,
      showMoreFilter: false, // 是否展示更多筛选
      loading: false,
      selectAllLoading: false,
      list: [],
      selectedList: [],
      params: {
        keyword: '',
        flag: 1,
        orderby: 'releaseDate',
        direction: 'desc'
      },
      pager: {
        pages: 0,
        pageSize: 50,
        total: 0,
        limit: 0,
        offset: 0,
        currentPage: 1
      },
      statusMap: [
        {
          label: this.$t('pc_biz_global_unpublished'),
          value: 0,
          type: 'failure'
        },
        {
          label: this.$t('pc_biz_global_unpublished'),
          value: 1,
          type: 'failure'
        },
        {
          label: this.$t('pc_biz_global_processing'),
          value: 2,
          type: 'success'
        },
        {
          label: this.$t('pc_biz_global_over'),
          value: 3,
          type: 'failure'
        }
      ],
      roleType: [
        {
          label: this.$t('pc_biz_select_training_IamChange'),
          value: 1
        },
        {
          label: this.$t('pc_biz_select_training_ImInCharge'),
          value: 2
        }
      ],
      publishDate: [],
      selectedBarrierAndMap: {}, // 关卡模式下checkbox选中
      mapBarrierMap: {}, // 关卡和地图的父子关系
      barrierIdMap: {}, // 关卡id: 对象
      checkAllModel: false,
      isIndeterminate: false // 根路径是否半选
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler: function() {
        this.dialogVisible = this.visible;
        if (this.visible) {
          this.init();
        }
      }
    }
  },
  methods: {
    init() {
      this.params = {
        keyword: '',
        flag: 1
      };
      this.pager = {
        pages: 0,
        pageSize: 50,
        total: 0,
        limit: 0,
        offset: 0,
        currentPage: 1
      };
      this.showMoreFilter = false;
      this.publishDate = [];
      this.mapBarrierMap = {};
      this.barrierIdMap = {};
      this.search(1);
      this.handleDefault();
    },
    search(page) {
      if (this.loading) return;
      this.loading = true;
      const data = {
        orderByDate: this.getOrderByDate(),
        orderBy: this.params.orderby,
        keyword: this.params.keyword.trim(),
        flag: this.params.flag,
        type: this.type,
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode
      };
      if (this.publishDate && this.publishDate.length > 1) {
        data.releaseStartDate = this.publishDate[0] + ' 00:00:00';
        data.releaseEndDate = this.publishDate[1] + ' 23:59:59';
      }
      const params = {
        limit: this.pager.pageSize,
        offset: page ? (page - 1) * this.pager.pageSize : this.pager.offset
      };
      const func = this.sp ? api.getSpTrainingmapsList : api.getTrainingMapsList;
      func(data, params).then((res) => {
        this.setMapBarrierMap(res.datas);
        this.list = res.datas;
        this.pager.pages = res.paging.pages;
        this.pager.offset = res.paging.offset;
        this.pager.total = res.paging.count;
        this.loading = false;
        this.$nextTick(() => {
          this.setChecked();
        });
      }).catch(() => {
        this.loading = false;
      });
    },
    getOrderByDate() {
      if (this.params.direction === 'desc') {
        return 0;
      }
      if (this.params.direction === 'asc') {
        return 1;
      }
      return undefined;
    },
    handleDefault() {
      if (!this.defaultValue) {
        this.selectedList = [];
      }
      this.selectedList = this.defaultValue.map((item) => {
        if (this.type === 0) {
          return {
            name: item.name,
            id: item.id
            // mapId: item.id
          };
        } else {
          const barrier = {
            name: item.name,
            id: item.id
            // barrierId: item.id
          };
          this.barrierIdMap[item.id] = barrier;
          this.mapBarrierMap[item.id] = '';
          return barrier;
        }
      });
    },
    // 处理列表中的选中项
    setChecked() {
      this.selectedBarrierAndMap = {};
      this.$refs.table.clearSelection();
      if (this.type === 0) {
        this.list.forEach(map => {
          const find = this.selectedList.find(v => v.id === map.id);
          if (find) {
            this.$refs.table && this.$refs.table.toggleRowSelection(map, true);
          } else {
            this.$refs.table && this.$refs.table.toggleRowSelection(map, false);
          }
        });
      } else {
        this.selectedList.forEach(item => {
          this.$set(this.selectedBarrierAndMap, item.id, true);
          const parentId = this.mapBarrierMap[item.id];
          if (parentId) {
            this.$set(this.selectedBarrierAndMap, parentId, this.isChildrenAllSelected(parentId));
          }
        });
        this.handleAllSelectedComputed();
      }
    },
    handleSortChange({ column, prop, order }) {
      this.params.orderby = prop;
      this.params.direction = order;
      this.search(1);
    },
    handleSelectionChange(val) {
      this.selectedList = val;
    },
    handleSelect(selection, row) {
      const isSelected = (list, data) => {
        return list.findIndex(item => item.id === data.id) > -1;
      };
      if (isSelected(selection, row)) {
        if (this.selectedList.length < this.limit) {
          this.selectedList.push(row);
        } else {
          this.$message.warning(this.$t('pc_biz_tmap_limit', [this.limit]));
          this.$refs.table.toggleRowSelection(row, false);
        }
      } else {
        const index = this.selectedList.findIndex(s => s.id === row.id);
        this.selectedList.splice(index, 1);
      }
    },
    handleSelectAll(selection) {
      const isSelected = selection.length > 0;
      let isOverBeforeStart = this.limit <= Object.values(this.selectedList).length;
      if (isSelected) {
        const tempMap = {};
        this.selectedList.forEach(item => {
          if (!tempMap[item.id]) {
            tempMap[item.id] = item;
          }
        });
        selection.forEach(item => {
          if (!tempMap[item.id]) {
            tempMap[item.id] = item;
          }
        });
        this.selectedList = Object.values(tempMap);
        if (this.selectedList.length > this.limit) {
          this.$message.warning(this.$t(isOverBeforeStart ? 'pc_biz_tmap_limit1' : 'pc_biz_tmap_limit2', [this.limit]));
          this.selectedList = this.selectedList.slice(0, this.limit);
          this.list.forEach(item => {
            const index = this.selectedList.findIndex(s => s.id === item.id);
            if (index === -1) {
              this.$refs.table.toggleRowSelection(item, false);
            }
          });
        }
      } else {
        this.list.forEach(item => {
          const index = this.selectedList.findIndex(selected => item.id === selected.id);
          this.selectedList.splice(index, 1);
        });
        // this.selectedList = this.selectedList.filter(item => !this.list.some(i => i.id === item.id));
      }
    },
    handleSelectionClose(item) {
      if (this.type === 0) {
        const index = this.selectedList.indexOf(item);
        this.selectedList.splice(index, 1);
        const itemInTable = this.list.find(v => v.id === item.id);
        if (itemInTable) {
          this.$refs.table.toggleRowSelection(itemInTable, false);
        }
      } else {
        this.selectedList.splice(this.selectedList.indexOf(item), 1);
        this.selectedBarrierAndMap[item.id] = false;
        const parentId = this.mapBarrierMap[item.id];
        if (parentId) {
          this.selectedBarrierAndMap[parentId] = false;
        }
        this.handleAllSelectedComputed();
      }
    },
    clearAllSelection() {
      if (this.type === 0) {
        this.$refs.table.clearSelection();
        this.selectedList = [];
      } else {
        this.selectedList = [];
        this.clearSelectedBarrierAndMap();
        this.handleAllSelectedComputed();
      }
    },
    clearSelectedBarrierAndMap() {
      this.selectedBarrierAndMap = {};
      this.list.forEach(map => {
        this.selectedBarrierAndMap[map.id] = false;
      });
    },
    getRowKey(row) {
      return row.id;
    },
    handleSelection() {
      if (this.selectedList.length >= this.limit) {
        this.$message.warning(this.$t('pc_biz_tmap_limit', [this.limit]));
        return;
      }
      if (!this.selectedList.length) {
        this.$message.warning(this.$t('pc_gwnl_pls_select_map'));
        return;
      }
      this.$emit('on-selection', this.selectedList.map(i => {
        return {
          name: i.name,
          id: i.id
        };
      }));
      this.$emit('update:visible', false);
    },
    beforeDrawClose() {
      this.cancel();
    },
    cancel() {
      let changed = false;
      if ((this.defaultValue || []).length !== this.selectedList.length) {
        changed = true;
      }
      for (let i = 0; i < this.defaultValue.length; i++) {
        if (!this.selectedList[i]) {
          changed = true;
          break;
        }
        if (this.defaultValue[i].id !== this.selectedList[i].id) {
          changed = true;
          break;
        }
      }
      if (changed) {
        this.$confirm(this.$t('pc_biz_gwnl_save_confirm'), this.$t('pc_common_tit_cancel'), {
          confirmButtonText: this.$t('pc_biz_labelling_confirm'),
          cancelButtonText: this.$t('pc_biz_common_cancel_mini'),
          type: 'warning'
        }).then(() => {
          this.$emit('update:visible', false);
        }).catch(() => {
        });
      } else {
        this.$emit('update:visible', false);
      }
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val;
      this.pager.offset = (this.pager.currentPage - 1) * this.pager.pageSize;
      this.search();
    },
    /**
     * 选关卡时做个地图和关卡的映射对象,同时将不同字段命名的id、name都放入id、name中
     * 地图 id：关卡id数组
     * 关卡 id：地图id
     * @param datas
     */
    setMapBarrierMap(datas) {
      // this.mapBarrierMap = {};
      // this.barrierIdMap = {};
      datas.forEach(map => {
        map.id = map.mapId;
        map.name = map.mapName;
        map.isMap = true;
        if (this.type !== 0) {
          // 层级
          this.mapBarrierMap[map.id] = [];
          if (map.barrier) {
            map.barrier.forEach((barrier) => {
              barrier.id = barrier.barrierId;
              barrier.name = barrier.barrierName;
              barrier.isMap = false;
              this.mapBarrierMap[map.id].push(barrier.id);
              this.mapBarrierMap[barrier.id] = map.id;
              this.barrierIdMap[barrier.id] = barrier;
            });
          }
        }
      });
    },
    barrierModeCheckboxChange(row) {
      const isMap = row.isMap;
      if (isMap) {
        if (!row.barrier) {
          return;
        }
        if (!this.mapBarrierMap[row.id]) {
          return;
        }
        this.mapBarrierMap[row.id].forEach(barrierId => {
          this.$set(this.selectedBarrierAndMap, barrierId, !!this.selectedBarrierAndMap[row.id]);
          let index = this.selectedList.findIndex((selectItem => selectItem.id === barrierId));
          if (this.selectedBarrierAndMap[row.id]) {
            if (index === -1) {
              this.selectedList.push(this.barrierIdMap[barrierId]);
            }
          } else {
            if (index !== -1) {
              this.selectedList.splice(index, 1);
            }
          }
        });
      } else {
        // 关卡九二点
        const parentId = this.mapBarrierMap[row.id];
        if (!parentId) {
          return;
        }
        if (!this.selectedBarrierAndMap[row.id]) {
          // 取消选择
          this.$set(this.selectedBarrierAndMap, parentId, false);
          this.selectedList.splice(this.selectedList.findIndex(selectItem => selectItem.id === row.id), 1);
        } else {
          // 选中
          this.selectedList.push(this.barrierIdMap[row.id]);
          this.$set(this.selectedBarrierAndMap, parentId, this.isChildrenAllSelected(parentId));
        }
      }
      this.handleAllSelectedComputed();
    },
    handleAllSelectedComputed() {
      let uncheckedMapList = this.list.filter(map => !this.selectedBarrierAndMap[map.id]);
      if (!uncheckedMapList.length) {
        // 全部选中
        this.isIndeterminate = false;
        this.checkAllModel = true;
        return;
      }
      if (uncheckedMapList.length !== this.list.length) {
        // 地图部分选中
        this.isIndeterminate = true;
        this.checkAllModel = false;
        return;
      }
      let isAllBarrierUnchecked = true;
      for (let i = 0; i < uncheckedMapList.length; i++) {
        if (!uncheckedMapList[i].barrier) {
          continue;
        }
        if (!isAllBarrierUnchecked) {
          break;
        }
        for (let j = 0; j < uncheckedMapList[i].barrier; j++) {
          if (uncheckedMapList[i].barrier[j] && this.selectedBarrierAndMap[uncheckedMapList[i].barrier[j]]) {
            isAllBarrierUnchecked = false;
            break;
          }
        }
      }
      if (isAllBarrierUnchecked) {
        this.isIndeterminate = false;
        this.checkAllModel = false;
      }
    },
    isChildrenAllSelected(parentId) {
      let isAllChildChecked = true;
      this.mapBarrierMap[parentId].forEach(barrierId => {
        if (!this.selectedBarrierAndMap[barrierId]) {
          isAllChildChecked = false;
        }
      });
      return isAllChildChecked;
    },
    barrierModeAllCheckboxChange(val) {
      if (!!val && this.selectedList.length >= this.limit) {
        this.$message.warning(this.$t('pc_biz_tmap_limit1', [this.limit]));
        this.handleAllSelectedComputed();
        return;
      }
      let tempMap = {};
      this.isIndeterminate = false;
      this.selectedList.forEach(selectedItem => {
        tempMap[selectedItem.id] = true;
      });
      this.selectedBarrierAndMap = {};
      this.list.forEach(map => {
        if (map.barrier) {
          map.barrier.forEach((barrier, index) => {
            if (!!val && this.selectedList.length >= this.limit) {
              this.$message.warning(this.$t('pc_biz_tmap_limit2', [this.limit]));
              return;
            }
            if (index === map.barrier.length - 1) {
              // 如果最后一个通过数量限制校验，则将改关卡所在地图勾选
              this.$set(this.selectedBarrierAndMap, map.id, !!val);
            }
            this.$set(this.selectedBarrierAndMap, barrier.id, !!val);
            if (val && !tempMap[barrier.id]) {
              this.selectedList.push(barrier);
            }
            if (!val && tempMap[barrier.id]) {
              this.selectedList.splice(this.selectedList.findIndex(selectItem => selectItem.id === barrier.id), 1);
            }
          });
        }
      });
      this.handleAllSelectedComputed();
    },
    selectAllData() {
      if (this.selectedList.length >= this.limit) {
        this.$message.warning(this.$t('pc_biz_tmap_limit1', [this.limit]));
        return;
      }
      this.selectAllLoading = true;
      const data = {
        orderByDate: this.getOrderByDate(),
        orderBy: this.params.orderby,
        keyword: this.params.keyword.trim(),
        flag: this.params.flag,
        type: this.type,
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode
      };
      if (this.publishDate && this.publishDate.length > 1) {
        data.releaseStartDate = this.publishDate[0] + ' 00:00:00';
        data.releaseEndDate = this.publishDate[1] + ' 23:59:59';
      }
      const params = {
        limit: 2001,
        offset: 0
      };
      const selectedList = [];
      const func = this.sp ? api.getSpTrainingmapsList : api.getTrainingMapsList;
      func(data, params).then((res) => {
        if (res.datas) {
          this.setMapBarrierMap(res.datas);
          let isOver = this.limit <= this.selectedList.length; // 是否超限
          let tempMap = {};
          this.selectedList.forEach(item => {
            tempMap[item.id] = item;
          });
          for (let i = 0; i < res.datas.length; i++) {
            const item = res.datas[i];
            if (isOver || (this.limit <= this.selectedList.length)) {
              isOver = true;
              break;
            } else {
              if (this.type === 0) {
                // 层级地图
                if (!tempMap[item.id]) {
                  // 不存在，追加
                  // this.selectedList.push(item);
                  // 如果在table中展示则需要同步勾选状态
                  const tableRow = this.list.find(r => r.id === item.id);
                  tableRow && this.$refs.table.toggleRowSelection(tableRow, true);
                  selectedList.push(item);
                }
              } else {
                // 关卡
                this.$set(this.selectedBarrierAndMap, item.id, true);
                if (item.barrier) {
                  for (let j = 0; j < item.barrier.length; j++) {
                    if (this.limit <= this.selectedList.length) {
                      isOver = true;
                      break;
                    }
                    const barrier = item.barrier[j];
                    this.$set(this.selectedBarrierAndMap, barrier.id, true);
                    // this.selectedList.push(barrier);
                    selectedList.push(barrier);
                  }
                }
              }
            }
          }
          this.selectedList = selectedList;
          if (this.type !== 0) {
            // 更新关卡和层级地图之间的checkbox关系
            this.handleAllSelectedComputed();
          }
          if (isOver) {
            // 部分选中提示
            this.$message.warning(this.$t('pc_biz_tmap_limit2', [this.limit]));
          }
        }
        this.selectAllLoading = false;
      }).catch(() => {
        this.selectAllLoading = false;
      });
    }
  },
  filters: {
    formatDate(val, formatType = 'yyyy-MM-dd HH:MM') {
      if (!val) return '';
      if (typeof val === 'string') {
        val = val.replace(/-/g, '/');
      }
      val = val.split('.')[0] ? val.split('.')[0] : val;
      return dateUtil.format(new Date(val), formatType);
    }
  }
};

</script>

